import { IUserProjectRoleModel } from '../../../../../../../../service/projectRole/entity/IUserProjectRoleModel';
import { RowContextMenuUI } from '../../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../../../design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';

export class UserProjectRoleContextMenuUI<RowType> extends RowContextMenuUI<IUserProjectRoleModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
